
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'CollapseButton',
    props: {
      levelOfNesting: {
        type: Number,
        default: 0,
      },
      toggleChildrenFn: {
        type: Function,
        required: true,
      },
    },
    methods: {
      handleClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleChildrenFn();
      },
    },
  });
